import { useAuth0 } from "@auth0/auth0-react";
import { ApiConnection } from "models/ApiConnection";
import { CmsPage } from "models/CmsPage";
import { Entities } from "models/Entities";
import { HttpMethod } from "models/HttpMethod";
import { NotificationResponse } from "models/NotificationResponse";

import { ApiService } from "../services/ApiService";


export const useApiConnectionService = (apiBaseUrl: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const connectionService = new ApiService<NotificationResponse>(apiBaseUrl, Entities.ApiConnections);

  const testConnection = async (connection: ApiConnection): Promise<NotificationResponse> => {
    const defaultCmsPage: CmsPage = {
      pageID: 1,
      documentId: 1,
      authorName: 'Admin',
      allowComments: false,
      allowRating: false,
      allowTagging: false,
      imageFileNameWithExtension: 'https://app.blabberjax.com/img/logo.png',
      description: 'test description',
      pageTitle: 'Test Page Title',
      publishedDate: new Date(),
      contentAreas: [
        {
          title: '',
          content: '<p>This is my test article content.</p>'
        }
      ],
      editableBy: 'administrator',
      keywords: 'test keywords',
      viewableBy: 'anonymous',
      sectionID: 1,
      categoryID: 0
    };

    const testData = {
      condition : connection.conditions[0],
      MessageId : 'TEST-CONNECTION',
      ProjectId : connection.projectId,
      Document : defaultCmsPage
    };

    connectionService.setAccessToken(await getAccessTokenSilently());
    const response = await connectionService.execute(
      `${connection.id}/TestConnection`,
      HttpMethod.POST,
      testData
    );

    if (response.ok) {
      return await response.json() as NotificationResponse;
    }
    
    return {
     isSuccessful: false,
     errorType: 'Test failed',
     errorMessage: 'Failed to call webhook due to an internal error.  Please try again in a few minutes.' 
    };
  }

  const reorderAll = async (allConnections: Array<{ id: number, orderId: number }>): Promise<boolean> => {
    connectionService.setAccessToken(await getAccessTokenSilently());
    const response = await connectionService.execute(
      `ReorderAll`,
      HttpMethod.PUT,
      allConnections
    );
    return response.ok;
  }

  return { testConnection, reorderAll };
}